import { Skeleton } from '@/ui/components/common/Skeleton'

/**
 * Loading placeholder mirroring the layout of an InvestigationCard while the
 * paginated investigations request is in flight.
 */
export function CardSkeleton() {
  return (
    <div className="bg-background border border-border rounded-lg overflow-hidden flex">
      <div className="w-40 sm:w-52 md:w-64 shrink-0">
        <Skeleton className="w-full h-full min-h-[148px]" />
      </div>
      <div className="flex-1 p-5 border-l-2 border-l-primary/30">
        <div className="flex items-start justify-between gap-3 mb-3">
          <Skeleton className="h-5 w-20 rounded-full" />
          <Skeleton className="h-4 w-24 ml-auto" />
        </div>
        <Skeleton className="h-6 w-3/4 mb-2" />
        <Skeleton className="h-4 w-full mb-1" />
        <Skeleton className="h-4 w-5/6 mb-4" />
        <Skeleton className="h-3 w-24" />
      </div>
    </div>
  )
}
